module.exports = __webpack_public_path__ + "4b7266f1fbf746cc1b7d369404ad1ee5.pdf";